define('plugin/classes/step/ClassesPluginTimeStep',['require','controller/step/datetime/BaseDateTimeStep','plugin/classes/collection/ClassesPluginCollection','plugin/classes/view/datetime/TimeClassesPluginView','collection/ServiceCollection','collection/ProviderCollection'],function (require) {

    var BaseDateTimeStep = require('controller/step/datetime/BaseDateTimeStep');
    var ClassesPluginCollection = require('plugin/classes/collection/ClassesPluginCollection');
    var TimeClassesPluginView = require('plugin/classes/view/datetime/TimeClassesPluginView');
    var ServiceCollection = require('collection/ServiceCollection');
    var ProviderCollection = require('collection/ProviderCollection');

    return BaseDateTimeStep.extend({

        _timeCollection: null,
        _providerCollection: null,
        _serviceCollection: null,

        initialize: function () {
            BaseDateTimeStep.prototype.initialize.apply(this);

            this.listenTo(this._bookingModel, 'change:count', this._fetchTimeCollection);
            this.listenTo(this._bookingModel, 'change:service_id', this._updateServiceInfo);
            this.listenTo(this._bookingModel, 'change:provider_id', this._updateProviderInfo);

            //this.initServiceCollection();
            //this.initProviderCollection();

            this.listenTo(this._stepManager, 'step:init:service', this.initServiceCollection);
            this.listenTo(this._stepManager, 'step:init:provider', this.initProviderCollection);

            var serviceStep = this._stepManager.getStepObject('service');
            var providerStep = this._stepManager.getStepObject('provider');

            serviceStep.triggerInit();
            providerStep.triggerInit();
        },

        /**
         * Returns true if date and time is set, else returns false
         *
         * @return Boolean
         */
        isValid: function () {
            if (this._bookingModel.get('start_date') && this._bookingModel.get('start_time') && this._bookingModel.get('service_id')) {
                if (!this._timeValidated) {
                    this._validateBookingTime();

                    return false;
                }

                return true;
            }
            return false;
        },

        /**
         * Returns data for validating time
         *
         * @protected
         */
        _getDataForTimeValidateInfo: function () {
            return {
                service_id: this._bookingModel.get('service_id'),
                start_date: this._bookingModel.get('start_date'),
                start_time: this._bookingModel.get('start_time'),
                count: this._bookingModel.get('count')
            };
        },


        initProviderCollection: function (step, collection) {
            this._providerCollection = collection;
            //console.log('provider ready');
            this._updateProviderInfo();
            this.listenTo(this._providerCollection, 'sync', this._updateProviderInfo);
        },

        initServiceCollection: function (step, collection) {
            this._serviceCollection = collection;
            //console.log('service ready');
            this._updateStepsInfo();
            this.listenTo(this._serviceCollection, 'sync', this._updateStepsInfo);
        },
        // /**
        //  * Set provider collection on setup service step.
        //  *
        //  * @param step
        //  * @param collection
        //  */
        // initProviderCollection: function (step, collection) {
        //     this._providerCollection = new ProviderCollection();
        //     this._providerCollection.fetch();
        //
        //     this.listenTo(this._providerCollection, 'sync', this._updateProviderInfo);
        // },
        //
        // /**
        //  * Set service collection on setup service step.
        //  *
        //  * @param step
        //  * @param collection
        //  */
        // initServiceCollection: function (step, collection) {
        //     this._serviceCollection = new ServiceCollection();
        //     this._serviceCollection.fetch();
        //
        //     this.listenTo(this._serviceCollection, 'sync', this._updateStepsInfo);
        // },

        /**
         * Inits time collection
         */
        _initTimeCollection: function () {
            this._timeCollection = new ClassesPluginCollection();
        },

        /**
         * After fetch services check if only classes present.
         * In this case we will hide provider step
         *
         * @private
         */
        _updateStepsInfo: function () {
            if (!this._serviceCollection) {
                return;
            }
            var services = this._serviceCollection.getDataCollection().where({
                class_id: null
            });

            if (!services.length) {
                this._stepManager.hideStep('provider');
            } else {
                this._stepManager.showStep('provider');
            }
            this._updateServiceInfo();
        },

        /**
         * Updates service info in booking
         *
         * @private
         */
        _updateServiceInfo: function () {
            this._bookingModel.set('service', this._serviceCollection.getDataCollection().getModelObj(
                this._bookingModel.get('service_id')
            ));
        },

        /**
         * Updates provider infor in booking
         *
         * @private
         */
        _updateProviderInfo: function () {
            //console.log(this._providerCollection);
            if (!this._providerCollection) {
                return;
            }
            this._bookingModel.set('provider', this._providerCollection.getDataCollection().getModelObj(
                this._bookingModel.get('provider_id')
            ));
        },

        /**
         * Returns time view
         *
         * @return TimeClassesPluginView
         */
        _getTimeView: function () {
            //console.log('time view');

/*            console.log({
                providerCollection: this._providerCollection,
                serviceCollection: this._serviceCollection});*/


            return new TimeClassesPluginView({
                providerCollection: this._providerCollection,
                serviceCollection: this._serviceCollection,
                classesCollection: this._timeCollection,
                bookingModel: this._bookingModel,
                timeValidateModel: this._timeValidateModel,
                clientTimeZone: this.getOption('clientTimeZone'),
                showNavigation: this._supportsTimelineNavigation,
                waitingListHelperModel: this.getOption('waitingListHelperModel'),
            });
        },
        
        beforeViewShow: function () {
            this._serviceCollection.performFilters();
        }

    });

});
